export async function getOwnerByEGRID(
  egrid: string,
  terravisApiUrl: string,
  captchaToken: string,
): Promise<any> {
  const url = `${terravisApiUrl}egrid/${egrid}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Captcha-Token': captchaToken,
      },
    });

    return response;
  } catch (error) {
    console.error('Error fetching owner data:', error);
    console.error('Fetching owner data failed for egrid:', egrid);
    throw error;
  }
}
